import { render } from "./BuyButtonWrapper.vue?vue&type=template&id=5ba5e767&scoped=true"
import script from "./BuyButtonWrapper.vue?vue&type=script&lang=js"
export * from "./BuyButtonWrapper.vue?vue&type=script&lang=js"

import "./BuyButtonWrapper.vue?vue&type=style&index=0&id=5ba5e767&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba5e767"]])

export default __exports__